import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';

import { ArchivioComponent } from './archivio/archivio.component';
import { ChatComponent } from './chat/chat.component';
import { NewsletterComponent } from './newsletter/newsletter.component';
import { UsersComponent } from './users/users.component';
import { ComunicazioniComponent } from './comunicazioni/comunicazioni.component';
import { AssegnazionePresenzeComponent } from './assegnazione-presenze/assegnazione-presenze.component';
import { MappaComponent } from './mappa/mappa.component';
import { OrganizerComponent } from './organizer/organizer.component';
import { CalendarComponent } from './calendar/calendar.component';
import { SettingsComponent } from './settings/settings.component';
import { AppSettingsComponent } from './app-settings/app-settings.component';
import { AlertComponent } from './alert/alert.component';
import { RepositoryComponent } from './repository/repository.component';
import { BlogComponent } from './blog/blog.component';

import { CustomModule } from './custom/custom.module';
const routes: Routes = [
  { path: 'users/:users-title/:users-type', component: UsersComponent },
  { path: '', redirectTo: 'users/clienti/cliente', pathMatch: 'full' },
  { path: 'clienti', redirectTo: 'users/clienti/cliente', pathMatch: 'full' },
  { path: 'dipendenti', redirectTo: 'users/dipendenti/dipendente', pathMatch: 'full' },
  { path: 'archivio', component: ArchivioComponent },
  { path: 'chat', component: ChatComponent },
  { path: 'newsletter', component: NewsletterComponent },
  { path: 'comunicazioni', component: ComunicazioniComponent },
  { path: 'assegnazioni', component: AssegnazionePresenzeComponent },
  { path: 'mappa', component: MappaComponent },
  { path: 'organizer', component: OrganizerComponent },
  { path: 'calendar', component: CalendarComponent },
  { path: 'settings', component: SettingsComponent },
  { path: 'alert', component: AlertComponent },
  { path: 'app-settings', component: AppSettingsComponent },
  { path: 'repository', component: RepositoryComponent },
  { path: 'blog', component: BlogComponent },
  { path: '**', redirectTo: 'users/clienti/cliente', pathMatch: 'prefix' },  // Wildcard route for a 404 page
];

@NgModule({
  imports: [RouterModule.forRoot(routes, { useHash: true }), CustomModule],
  exports: [RouterModule]
})
export class AppRoutingModule { }
